<!--
  ~ Copyright (C) 2023 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="add-content-dialog">
  <div class="dialog-top-info">
    <div class="dialog-title large">
      {{ 'translations.pages.dialog.title.addExternalLink' | transloco }}
    </div>
    <p class="dialog-description small">{{ 'translations.pages.dialog.description.addExternalLink' | transloco }}</p>

    <button
      class="close-dialog-btn f_close-btn"
      (click)="onClose()"
      mat-icon-button
      color="primary"
      [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
    >
      <svg class="svg" role="img" aria-hidden="true">
        <use ogSvgUnify="assets/sprite/sprite.svg#close"></use>
      </svg>
    </button>
  </div>

  <div class="add-link-container">
    <div class="info-container">
      <div class="editor-item">
        <h2 class="editor-item-title small bold">{{ 'translations.summary.title.url' | transloco }}</h2>
        <p class="editor-item-description extra-small">
          {{ 'translations.summary.title.passUrl' | transloco }}
        </p>

        <input
          matInput
          class="editor-item-input"
          type="text"
          [attr.aria-label]="'translations.global.ariaLabels.enterOrPasteLink' | transloco"
          [class.has-error]="linkError || (linkToData.uid && !linkToData.link)"
          (ngModelChange)="linkError ? (linkError = false) : ''"
          [(ngModel)]="linkToData.link"
        />
      </div>

      <div class="link-mode-options-container">
        <div class="link-mode-options">
          <button
            class="option-button"
            title="Existing groups"
            type="button"
            (click)="linkToData.linkStyle = 'TEXT_COLOR_BACKGROUND'"
            [ngClass]="{
              selected: linkToData.linkStyle === 'TEXT_COLOR_BACKGROUND',
            }"
          >
            <span class="title small"> {{ 'translations.pageSection.featuredLink.radio.linkToDisplayTextOnBackground' | transloco }}</span>
          </button>
          <button
            class="option-button"
            title="Upload groups"
            type="button"
            (click)="linkToData.linkStyle = 'TEXT_IMAGE_BACKGROUND'"
            [ngClass]="{
              selected: linkToData.linkStyle === 'TEXT_IMAGE_BACKGROUND',
            }"
          >
            <span class="title small">
              {{ 'translations.pageSection.featuredLink.radio.linkToDisplayTextOnImage' | transloco }}
            </span>
          </button>
          <button
            class="option-button"
            title="Upload groups"
            type="button"
            (click)="linkToData.linkStyle = 'TEXT_IMAGE'"
            [ngClass]="{
              selected: linkToData.linkStyle === 'TEXT_IMAGE',
            }"
          >
            <span class="title small">
              {{ 'translations.pageSection.featuredLink.radio.linkToDisplayTextAndImage' | transloco }}
            </span>
          </button>
        </div>
      </div>

      <ng-container *ngIf="linkToData.linkStyle === 'TEXT_COLOR_BACKGROUND'">
        <div class="editor-item">
          <h2 class="editor-item-title small bold">
            {{ 'translations.pageSection.featuredLink.label.linkToStepAddDisplayText' | transloco }}
          </h2>

          <textarea
            matInput
            class="editor-item-input"
            [attr.aria-label]="'translations.global.ariaLabels.enterDisplayText' | transloco"
            [(ngModel)]="linkToData.text"
            [class.has-error]="textError || (linkToData.uid && !linkToData.text)"
            rows="3"
            placeholder="Enter text"
          ></textarea>
        </div>

        <div class="link-to-section">
          <div class="link-to-step-type-container">
            <div class="display-views">
              <div class="display-view-option">
                <div class="link-to-step">
                  <span class="link-to-description">{{
                    'translations.pageSection.featuredLink.label.linkToStepLookAndFeelColor' | transloco
                  }}</span>
                  <div class="link-to-step-option">
                    <span class="label">{{ 'translations.pageSection.featuredLink.label.linkToStepColor' | transloco }}</span>
                    <label class="color" [style.background]="linkToData.fontColor">
                      <input
                        readonly
                        class="color-picker"
                        [attr.aria-label]="'translations.global.ariaLabels.enterTextColor' | transloco"
                        [(colorPicker)]="linkToData.fontColor"
                        [cpPosition]="'top'"
                        [cpOutputFormat]="'hex'"
                      />
                    </label>
                    <span class="color-section">{{ linkToData.fontColor }}</span>
                  </div>
                  <div class="link-to-step-option">
                    <span class="label">{{ 'translations.pageSection.featuredLink.label.linkToStepBgColor' | transloco }}</span>
                    <label class="color" [style.background]="linkToData.backgroundColor">
                      <input
                        readonly
                        class="color-picker"
                        [attr.aria-label]="'translations.global.ariaLabels.enterBackgroundColor' | transloco"
                        [(colorPicker)]="linkToData.backgroundColor"
                        [cpPosition]="'top'"
                        [cpOutputFormat]="'hex'"
                      />
                    </label>
                    <span class="color-section">{{ linkToData.backgroundColor }}</span>
                  </div>
                  <div class="link-to-step-option">
                    <span class="label">{{ 'translations.pageSection.featuredLink.label.linkToStepFontSize' | transloco }}</span>
                    <input
                      type="number"
                      [attr.aria-label]="'translations.global.ariaLabels.enterFontSize' | transloco"
                      class="font-size"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="linkToData.fontSize"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="linkToData.linkStyle !== 'TEXT_COLOR_BACKGROUND'">
        <div class="editor-item">
          <h2 class="editor-item-title small bold">{{ 'translations.completion.title.title' | transloco }}</h2>

          <input
            class="editor-item-input"
            [attr.aria-label]="'translations.global.ariaLabels.addATitle' | transloco"
            [class.has-error]="headlineError || (linkToData.uid && !linkToData.headline)"
            matInput
            type="text"
            [(ngModel)]="linkToData.headline"
          />
        </div>

        <div class="editor-item">
          <h2 class="editor-item-title small bold">{{ 'translations.completion.title.subLine' | transloco }}</h2>

          <input
            class="editor-item-input"
            matInput
            type="text"
            [attr.aria-label]="'translations.global.ariaLabels.addASubheader' | transloco"
            [(ngModel)]="linkToData.subLine"
          />
        </div>
      </ng-container>
    </div>

    <div class="preview-container">
      <div class="preview-item" *ngIf="linkToData.linkStyle !== 'TEXT_COLOR_BACKGROUND'">
        <div class="display-view-thumbnail-settings">
          <mat-card class="card" [class.text-on-image]="linkToData.linkStyle === 'TEXT_IMAGE_BACKGROUND'">
            <div class="card-center">
              <button
                *ngIf="linkToData.previewImage || linkToData.thumbnail"
                mat-button
                class="button-remove"
                title="Remove thumbnail"
                (click)="onThumbnailRemove()"
              >
                <mat-icon aria-hidden="true" [inline]="true">clear</mat-icon>
              </button>
              <img
                class="center-image"
                alt=""
                width="266"
                height="150"
                [src]="
                  linkToData.previewImage
                    ? linkToData.previewImage
                    : linkToData.thumbnail
                      ? linkToData.thumbnail
                      : '../../../../assets/card-placeholders/card-placeholder-1.png'
                "
              />
            </div>
            <div class="card-info-box">
              <div class="card-header small bold">
                {{ linkToData.headline }}
              </div>
              <div class="card-description extra-small">
                {{ linkToData.subLine }}
              </div>
            </div>
          </mat-card>
          <div class="display-view-thumbnail-buttons">
            <button mat-stroked-button color="accent" class="display-view-change-thumbnail-btn" (click)="openCoverImageDialog()">
              {{ 'translations.completion.button.replaceImage' | transloco }}
              <mat-spinner
                class="display-view-change-thumbnail-btn-spinner"
                *ngIf="thumbnailUploadInProgress"
                [color]="'blue'"
                [diameter]="20"
              ></mat-spinner>
            </button>
          </div>
          <div class="extra-small italic preview-text">This is a preview of your link</div>
        </div>
      </div>

      <div class="preview-item" *ngIf="linkToData.linkStyle === 'TEXT_COLOR_BACKGROUND'">
        <div class="text-color-background-container">
          <mat-card class="card" [ngStyle]="{ 'background-color': linkToData.backgroundColor }">
            <div class="card-text-container">
              <p class="card-text" [ngStyle]="{ color: linkToData.fontColor, 'font-size': linkToData.fontSize + 'px' }">
                {{ linkToData.text }}
              </p>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons-container">
    <button
      mat-flat-button
      color="accent"
      class="cancel-btn"
      [attr.aria-label]="'translations.global.ariaLabels.cancel' | transloco"
      type="button"
      (click)="cancel()"
    >
      <span>{{ 'translations.global.button.cancel' | transloco }}</span>
    </button>

    <button
      mat-flat-button
      color="potentially"
      class="add-btn"
      [attr.aria-label]="
        data?.editableLink
          ? ('translations.global.ariaLabels.updateLink' | transloco)
          : ('translations.global.ariaLabels.addLink' | transloco)
      "
      type="button"
      (click)="addLinkToPlaylist()"
    >
      <span *ngIf="!data?.editableLink">{{ 'translations.pageSection.button.addLink' | transloco }}</span>
      <span *ngIf="data?.editableLink">{{ 'translations.pageSection.button.updateLink' | transloco }}</span>
    </button>
  </div>
</div>
